<template>
    <div>
        <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'目标对阵用户'}]" />-->
        <Breadtabsheader/>
        <div class="h-content">
            <!---------------------------------------- 搜素条件 --------------------------------------->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="年度" prop="year">
                            <el-select filterable v-model="q.year" :clearable="true">
                                <el-option
                                    v-for="(item) in qyearList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户单位">
                            <el-input v-model="q.userUnitName" placeholder="请输入用户单位" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="渠道" prop="chanel">
                            <el-select v-model="q.scenesCode" clearable placeholder="请选择" style="width:100%">
                                <el-option v-for="item in qudaoList"
                                           :key="item.code"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="q.status" :clearable="true">
                                <el-option label="正常" value="1"></el-option>
                                <el-option label="删除审批中" value="2"></el-option>
                                <el-option label="修改审批中" value="3"></el-option>
                                <el-option label="驳回审批中" value="4"></el-option>
                                <el-option label="导入审批中" value="5"></el-option>
                                <el-option label="新增审批中" value="6"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                  <div class="h-thirdColumn w-newColumn">
                    <el-form-item label="省" prop="province">
                      <el-select v-model="q.province" filterable clearable @change="handleItemChange1($event)"  :disabled = "disEdit"
                                 placeholder="省" style="width: 80%;">
                        <el-option
                            v-for="item in shenglist"
                            :key="item.value"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="地市" prop="city">
                      <el-select v-model="q.city" filterable clearable @change="handleItemChange2($event)"  :disabled = "disEdit"
                                 placeholder="市" style="width: 100%;">
                        <el-option
                            v-for="item in cityList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                      </el-select>
                    </el-form-item>
<!--                  </div>-->
<!--                    <div class="h-thirdColumn w-newColumn">-->
                        <el-form-item label="创建人">
                            <el-input v-model="q.cuname" placeholder="请输入名称或工号" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="变更类型">
                            <el-select v-model="q.topChangeType" :clearable="true">
                                <el-option label="修改" value="update"></el-option>
                                <el-option label="新增" value="add"></el-option>
                                <el-option label="删除" value="del"></el-option>
                                <el-option label="导入" value="improt"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                  <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="创建时间" style="width: 50%;">
                    <el-date-picker
                        v-model="q.cdatebegin"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                    <span class="w-time-to">至</span>
                    <el-date-picker
                        v-model="q.cdateend"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                  </el-form-item>
                    <el-form-item label="修改时间" style="width: 50%;">
                      <el-date-picker
                          v-model="q.ldatebegin"
                          clearable
                          type="date"
                          value-format="yyyy-MM-dd" >
                      </el-date-picker>
                      <span class="w-time-to">至</span>
                      <el-date-picker
                          v-model="q.ldateend"
                          clearable
                          type="date"
                          value-format="yyyy-MM-dd" >
                      </el-date-picker>
                    </el-form-item>

                  </div>
                </el-form>
                <!----------------------------------- 展开搜素 ---------------------------------------------->
                <div class="l-screenBox">
                    <!-- <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                    </div> -->
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen"  v-if="!isjlFlag && changeFlag" icon="el-icon-plus" @click="create">
                            新增
                        </el-button>
                        <!-- <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                            新建目标
                        </el-button> -->
                    </div>
                </div>
            </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        fixed
                        width="50">
                    </el-table-column>
                    <el-table-column prop="year" label="年度" width="60px"></el-table-column>
                    <el-table-column prop="userUnitName" label="用户单位" width="140px" >
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.userUnitName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="province" label="省份" width="90px"></el-table-column>
                    <el-table-column prop="city" label="地市" width="90px"></el-table-column>
                    <el-table-column prop="scenesName" label="渠道" width="90px"></el-table-column>
                    <el-table-column prop="schoolTypeName" label="用户分类" width="90px"></el-table-column>
                    <el-table-column prop="isNew" label="是否新建">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isNew == 0">否</span> <span v-if="scope.row.isNew == 1">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isZhidan" label="是否直单">
                    <template slot-scope="scope">
                    <span v-if="scope.row.isZhidan == 0">否</span> <span v-if="scope.row.isZhidan == 1">是</span>
                    </template>
                    </el-table-column>
                    <!-- <el-table-column prop="isAgainst" label="是否对阵">
                    <template slot-scope="scope">
                    <span v-if="scope.row.isAgainst == 0">否</span> <span v-if="scope.row.isAgainst == 1">是</span>
                    </template>
                    </el-table-column> -->
                    <el-table-column prop="dzCustomerName" :label="'对阵经销商名称'" width="130px"></el-table-column>
                    <!-- <el-table-column prop="dzCustomerCode" :label="'对阵经销商编号'" width="130px"></el-table-column> -->
                    <el-table-column prop="q1Target" :label="'Q1目标\n(万元)'" width="90px"></el-table-column>
                    <el-table-column prop="q2Target" :label="'Q2目标\n(万元)'" width="90px"></el-table-column>
                    <el-table-column prop="q3Target" :label="'Q3目标\n(万元)'" width="90px"></el-table-column>
                    <el-table-column prop="q4Target" :label="'Q4目标\n(万元)'" width="90px"></el-table-column>
                    <el-table-column prop="status" label="状态" width="120px">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.status == '' || scope.row.status == null">正常</span>
                                <span v-if="scope.row.status == 1">正常</span>
                                <span v-if="scope.row.status == 2">删除审批中</span>
                                <span v-if="scope.row.status == 3">修改审批中</span>
                                <!--                <span v-if="scope.row.status == 4">驳回审批</span>-->
                                <span v-if="scope.row.status == 5">导入审批中</span>
                                <span v-if="scope.row.status == 6">新增审批中</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="cuname" label="创建人" width="100px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="140px" ></el-table-column>
                    <el-table-column prop="ldate" label="修改时间" width="140px" ></el-table-column>
                    <el-table-column prop="topChangeType" label="变更类型" width="140px" >
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.topChangeType == 'update'">修改</span>
                                <span v-if="scope.row.topChangeType == 'add'">新增</span>
                                <span v-if="scope.row.topChangeType == 'del'">删除</span>
                                <span v-if="scope.row.topChangeType == 'improt'">导入</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="memo" label="变更原因" width="140px" ></el-table-column>

                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="325"
                    >
                        <template slot-scope="scope"
                                  v-if="scope.row.delflag == 1"
                        >
                            <el-button
                                size="small" class="h-tableLink h-btn"
                                @click="handleEdit(scope.row)">修改
                            </el-button>
                            <el-button size="small" class="h-tableLink h-btn" type="text"
                                       v-if="scope.row.instid != null"
                                       @click="showshenpi(scope.row.instid)"
                                       v-show="scope.row.instid">跟踪
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                v-if="scope.row.topChangeType == 'update'"
                                @click="showHistory(scope.row)"
                                class="h-tableLink h-btn">
                                修改记录
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                v-if="scope.row.topInstid!= null"
                                @click="spRecord(scope.row)"
                                class="h-tableLink h-btn">
                                审批记录
                            </el-button>
                        </template>
                    </el-table-column>


                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
                            <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-delete" v-if="!isjlFlag && changeFlag" @click="deleteSelete">批量删除
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelAll">批量导出
                            </el-button>
                            <!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">导出目标
                            </el-button> -->
                            <el-button class="h-btn h-formBtn h-bgblueQ" v-if="!isjlFlag && changeFlag" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                :visible.sync="uploaddownexcelflag"
                                v-if="uploaddownexcelflag"
                                clsname="bscTopManagementUserExcel"
                                :startrow="2" @callback="uploadExcelFilecallback"/>
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="selectPageAll"/>
                    </div>
                </div>
            </div>

            <!--------------------------------- 新增弹出层 -------------------------------------->
            <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2" >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{ titleDig }}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;">
                        <el-form :model="add" ref="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="年度" prop="year">
                                <el-select filterable v-model="add.year" :clearable="true"  >
                                    <el-option
                                        v-for="(item) in qyearList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="用户单位" prop="userUnitName">
                                <el-select v-model="add.userUnitName" remote filterable :filter-method="showGroupList" :clearable="true"
                                           style="width: 140px;"
                                           placeholder="请输入"
                                           :remote-method="showGroupList" @change="showGroupList"  >
                                    <el-option v-for="(item,index) in customerNameList"
                                               :key="index"
                                               :label="item.deptName"
                                               :value="item.deptName">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                          <el-form-item label="省份" prop="province">
                            <el-select v-model="add.province" filterable clearable @change="handleItemChange1($event)"
                                       placeholder="省" style="width: 80%;">
                              <el-option
                                  v-for="item in shenglist"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.code">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="地市" prop="city">
                            <el-select v-model="add.city" filterable clearable @change="handleItemChange3($event)"
                                       placeholder="市" style="width: 100%;">
                              <el-option
                                  v-for="item in cityList"
                                  :key="item.name"
                                  :label="item.name"
                                  :value="item.name">
                              </el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item label="渠道" prop="scenesCode">
                            <brselect category="sales_region" :v="add.scenesCode" @change="changeChannel($event)" :showcode="true"
                                      v-model="add.scenesCode" filterable clearable></brselect>
                          </el-form-item>


                          <el-form-item  label="用户分类" prop="schoolTypeName">
                            <el-select v-model="add.schoolTypeName"
                                       @change="changeSchoolType($event)" filterable clearable>
                              <el-option v-for="item in addressTypeList"
                                         :key="item.id"
                                         :label="item.userUnit"
                                         :value="item.userUnit">
                              </el-option>
                            </el-select>
                          </el-form-item>





                            <el-form-item label="是否新建" prop="isNew" v-model="this.add.isNew" >
                                <el-radio v-model="add.isNew" :label="1">是</el-radio>
                                <el-radio v-model="add.isNew" :label="0"> 否</el-radio>
                            </el-form-item>
                          <el-form-item label="是否直单" prop="isZhidan" v-model="this.add.isZhidan" >
                            <el-radio v-model="add.isZhidan" :label="1">是</el-radio>
                            <el-radio v-model="add.isZhidan" :label="0"> 否</el-radio>
                          </el-form-item>
                            <el-form-item  label="Q1目标(万元)" prop='q1Target' >
                                <el-input v-model="add.q1Target"  placeholder="请输入">
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="Q2目标(万元)" prop='q2Target' >
                                <el-input v-model="add.q2Target"  placeholder="请输入">
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="Q3目标(万元)" prop='q3Target' >
                                <el-input v-model="add.q3Target"  placeholder="请输入">
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="Q4目标(万元)" prop='q4Target' >
                                <el-input v-model="add.q4Target"  placeholder="请输入">
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="变更原因" prop='memo'>
                                <el-input v-model="add.memo"  placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialogs">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()" v-if ="!disAdd">提交</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()" v-if ="disEdit && disAdd">提交修改</el-button>
                    </div>
                </div>
            </el-dialog>
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
        <!-- 修改记录查看-->
        <el-dialog
            title=""
            :visible.sync="updateRecordFlag"
            :fullscreen="false"
            width="70%"
            :modal="true"
            :before-close="handleClose" class="h-dialog2">
            <h3>&nbsp;</h3>
            <div class="tanBox">
                <el-table
                    :data="tableDatahi"
                    border
                    max-height="420"
                    style="width: 94%; margin:0 auto;">
                    <el-table-column
                        label="序号"
                        type="index"
                        fixed
                        width="50">
                    </el-table-column>
                    <el-table-column prop="year" label="类型" width="100px">
                        <template slot-scope="scope">
                            <span v-if="scope.row.xiugaitype == 1">修改后数据</span>
                            <span v-if="scope.row.xiugaitype == 2">修改前数据</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="year" label="年度" width="60px"></el-table-column>
                    <el-table-column prop="userUnitName" label="用户单位" width="140px" >
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].userUnitName!=scope.row.userUnitName? baseClass:'']">
                                {{scope.row.userUnitName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="province" label="省份" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].province!=scope.row.province? baseClass:'']">
                                {{scope.row.province}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="scenesName" label="渠道" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].scenesName!=scope.row.scenesName? baseClass:'']">
                                {{scope.row.scenesName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="schoolTypeName" label="用户分类" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].schoolTypeName!=scope.row.schoolTypeName? baseClass:'']">
                                {{scope.row.schoolTypeName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isNew" label="是否新建">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].isNew!=scope.row.isNew? baseClass:'']">
                                <span v-if="scope.row.isNew == 0">否</span> <span v-if="scope.row.isNew == 1">是</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isZhidan" label="是否直单">
                      <template slot-scope="scope">
                        <div :class="[tableData[0].isZhidan!=scope.row.isZhidan? baseClass:'']">
                          <span v-if="scope.row.isZhidan == 0">否</span> <span v-if="scope.row.isZhidan == 1">是</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="q1Target" :label="'Q1目标\n(万元)'" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].q1Target!=scope.row.q1Target? baseClass:'']">
                                {{scope.row.q1Target}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="q2Target" :label="'Q2目标\n(万元)'" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].q2Target!=scope.row.q2Target? baseClass:'']">
                                {{scope.row.q2Target}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="q3Target" :label="'Q3目标\n(万元)'" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].q3Target!=scope.row.q3Target? baseClass:'']">
                                {{scope.row.q3Target}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="q4Target" :label="'Q4目标\n(万元)'" width="90px">
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].q4Target!=scope.row.q4Target? baseClass:'']">
                                {{scope.row.q4Target}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="luname" label="修改人" width="100px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="140px" ></el-table-column>
                    <el-table-column prop="memo" label="变更原因" width="140px" >
                        <template slot-scope="scope">
                            <div :class="[tableDatahi[0].memo!=scope.row.memo? baseClass:'']">
                                {{scope.row.memo}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="display:flex;justify-content: flex-end;align-items:center;margin-top:20px">
                <paginationmin :page="mf" @query="handleMessage"/>
            </div>
        </el-dialog>
        <!--    //审批记录查看-->
        <el-dialog
            title=""
            :visible.sync="spFlagRecord"
            :fullscreen="false"
            width="70%"
            :modal="true"
            :before-close="handleClose" class="h-dialog2">
            <h3>&nbsp;</h3>
            <div class="tanBox">
                <el-table
                    :data="tableSpData"
                    border
                    max-height="420"
                    style="width: 94%; margin:0 auto;">
                    <el-table-column
                        type="index"
                        width="45"
                        label="#">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="提交节点"
                        width="110"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="dbrname"
                        label="经办人"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="shpyj"
                        label="审批意见"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="begindate"
                        label="经办时间"
                        width="160"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="enddate"
                        label="办理时间"
                        width="100"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="shpopt"
                        label="审批操作"
                        width="100"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="beizhu"
                        label="备注"
                        width="100"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table>
            </div>
            <!--      <div style="display:flex;justify-content: flex-end;align-items:center;margin-top:20px">-->
            <!--        <paginationmin :page="mf" @query="spRecordMessage"/>-->
            <!--      </div>-->
        </el-dialog>
    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import agentCopyService from "@/api/loud/agent/agentCopyService";

export default {
    data() {
        return {
            baseClass: 'active', // 基础类名
            q: {
                year: '',
                schoolTypeName: '',
                scenesCode: '',
                status: '',
                pageNo: 1,
                pageSize: 10,
                total: 0,
                userUnitName:'',
                userUnitCode:'',
                cuname :'',
                topChangeType:'',
                city:'',
              province:'',
              cdatebegin:'',
              cdateend:'',
              ldatebegin:'',
              ldateend:'',


            },
            allq: {
                customerName:'',
                customerCode:'',
            },
            tableDatahi:[],
            tableSpData: [],
            spDatabiao:[],
            updateRecordFlag:false,
            spFlagRecord:false,
            mf: {
                pageSize: 10,
                pageNo: 1,
            },

            instid:null,
            topInstid:null,
            // userUnitName:'',
            xiugaiData: {
                userUnitName:'',
            },
            showhistory:null,
            centerDialogVisible:false,
            qyearList: [],
            quyuList: [],
            qudaoList: [],
            size: '',
            tableData: [],
            //表格
            multipleSelection: [],
            // 展开折叠筛选
            isScreen: false,
            uploaddownexcelflag: false,
            newDialog: false,
            editDialog: false,
            today: new Date(),
            changeFlag: true,
            isjlFlag:false,
            isAdmin:false,
            yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
            weekList: [],
            top_id: '',
            add: {
                year: '',//年份
                id:'',
                province:'',//省份
                provinceId:'',//省份编码
                city:'',//地市
                cityId:'',//地市编号
                scenesCode:'',//渠道
                userUnitName:'',//用户单位name
                userUnitCode:'',//用户编码
                bscAddressDataId:'',//用户单位主键
                schoolTypeName:'',//用户分类name
                schoolTypeCode:'',//用户分类编码
                isNew:'',//是否新建
                isZhidan:'',//是否直单
                // isTop:'',//是否top
                isAgainst:'',//是否对阵
                q1Target:'',//Q1目标
                q2Target:'',//Q2目标
                q3Target:'',//Q3目标
                q4Target:'',//Q4目标
                memo:'', //备注
              provinceList: [],
            },
            edit: {
                id: '',
                deId: '',
                userList: [0],
                targetContent: '',
                customerName: '',
                visitDateNew: '',
                clearType: ''
            },
            authTypeListEdit: [],
            disEdit: false,
            disAdd:false,
            workList: [],
            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList: [],
            groupList: [],
            groupArr: [],
            oneAgentList: [],
            showDel:false,
            titleDig: "",
            iscontract : '',//是否维护了合同
            refid:this.$util.getUuid(),
            shenglist: [],// 省份list
            cityList: [],      //城市list
            customerNameList: [], //用户单位list
            agentList: [],      //签约经销商
          addressTypeList:[],
            targetId:[],
            editFormRules: {
                year:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                userUnitName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                province:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                city:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                scenesCode:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                schoolTypeName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                isNew:[{required: true, message: '请输入必填项', trigger: 'change'}],
                isZhidan:[{required: true, message: '请输入必填项', trigger: 'change'}],
                // isTop:[{required: true, message: '请输入必填项', trigger: 'change'}],
                // isAgainst:[{required: true, message: '请输入必填项', trigger: 'change'}],
                q1Target:[{required: true, message: '请输入必填项', trigger: 'change'}],
                q2Target:[{required: true, message: '请输入必填项',trigger: 'change'}],
                q3Target:[{required: true, message: '请输入必填项',trigger: 'change'}],
                q4Target:[{required: true, message: '请输入必填项',trigger: 'change'}],
                memo:[{required: true, message: '请输入必填项',trigger: 'change'}],
            },
        }

    },

    methods: {

        //   tableRowClassName({row, rowIndex}) {
        //     if (rowIndex === 1) {
        //       return 'warning-row';
        //     } else if (rowIndex === 3) {
        //       return 'success-row';
        //     }
        //     return '';
        //   }
        // },
        //表格
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //关闭弹出框
        handleClose(v) {
            this.mf.userCode = '';
            this.mf.pageNo =  1;
            v()
        },
        deleteSelete() {
            console.log(111111111111);
            console.log(this.$store.getters.hasRole('swyl_quyujl'),"swyl_quyujl" );
            console.log(this.$store.getters.hasRole('swyl_daqujl'),"swyl_daqujl");
            // if(this.$store.getters.hasRole('swyl_quyujl') || this.$store.getters.hasRole('swyl_daqujl')) {
            var idlist = [];
            this.multipleSelection.forEach(element => {
                let querys = {};
                querys.id= element.id;
                querys.status = element.status;
                idlist.push(querys);
            });
            console.log(idlist)
            this.deleteSingle(idlist)
            // }
            // else {
            //   var idlist = [];
            //   this.multipleSelection.forEach(element => {
            //     let querys = {};
            //     querys.id= element.id;
            //     querys.status = element.status;
            //     idlist.push(querys);
            //   });
            //   console.log(idlist)
            //   this.deleteSingle(idlist)
            // }
        },
        showshenpi(v){
            this.instid = v;
            this.showhistory = true;
        },

      // 省份选择器
      handleItemChange1(o, salesman, city) {
          // this.a.city = null;
        if(o == ""){
          return
        }
        this.city = city;
        if (city == null) {
          this.city = null;
        }
        this.add.provinceList = _.find(this.shenglist, {code: o});
        ss.Dictservice.getCity({code: o}).then(rd => {
          this.cityList = rd.zlist;
        })
      },

      handleItemChange2(o) {
        this.q.city = o;
      },

      handleItemChange3(o) {
        this.add.city = o;
      },
      //渠道改变
      changeChannel(value){
        console.log("value111111111",value)
        ss.nxAddress.getAddressTypeByChannel(value.code).then(rd =>{
          this.addressTypeList = rd.msg;
          // this.add.schoolTypeName = '';
        })
      },

      changeSchoolType(value){
        console.log(value,"value20240314")
        this.add.schoolTypeName = value;
      },

        handleMessage() {
            ss.grabOrderApi.queryTopRecord(this.mf).then(rd => {
                this.mf.total = rd.total;
                this.tableDatahi = rd.records;
            })
        },
        showHistory(v){
            if(v && v.id){
                this.top_id = v.id;
            }
            var m = {
                pageSize: 10,
                pageNo: 1,
                topId: this.top_id
            }

            ss.grabOrderApi.queryTopRecord(m).then(rd => {
                this.mf.total = rd.total;
                this.tableDatahi = rd.records;
                this.mf.userCode = v.usercodeInfo;
                this.updateRecordFlag = true;
            })
        },

        spRecord(v){
            var m = {
                pageSize: 10,
                pageNo: 1,
                Instid:v.topInstid,
            }
            ss.taskservice.selectByInstid(m).then(rd => {
                // this.mf.total = rd.total;
                console.log(rd,"rd.records");
                this.tableSpData = rd;
                // this.mf.userCode = v.usercodeInfo;
                this.spFlagRecord = true;
            })
        },
        spRecordMessage() {
            ss.taskservice.selectByInstid(this.mf).then(rd => {
                // this.mf.total = rd.total;
                this.tableSpData = rd.records;
            })
        },

        deleteSingle(id) {
            console.log("id", id)
            var data = id
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ss.grabOrderApi.deleteTopManagementUser(data).then(res => {
                    console.log(res)
                    if (res.f == true) {
                        if(this.$store.getters.hasRole('swyl_quyujl')||this.$store.getters.hasRole('swyl_daqujl')){
                            this.$message({
                                type: 'success',
                                message: '提交成功!'
                            });
                        }else {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                        this.centerDialogVisible =false;
                        this.selectPageAll()
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        selectPageAll() {
            console.log("this.targetId", this.targetId);
          for(var i=0; i< this.shenglist.length; i++){
                if(this.shenglist[i].code == this.q.province){
                  this.q.province = this.shenglist[i].name;
                  break;
                }
          }
            ss.grabOrderApi.selectPageTopManagementUser(this.q).then(res => {
                console.log(res)
                console.log("total", res.total)
                this.tableData = res.records
                this.q.total = res.total
                //获取重复id
                // for(var i=0;i<this.tableData.length;i++){
                //   if(this.targetId.includes(this.tableData[i].id)){
                //     this.tableData[i].cloor = true
                //   }else {
                //     this.tableData[i].cloor = false
                //   }
                // }
                console.log("table", this.tableData)
            })
        },
        //导入
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(rd) {
            this.$msg.msgs(rd.msg);
            this.selectPageAll()
        },
        // changeTop(val){
        //   console.log("changeTop",val);
        // },


        //导出
        // exportExcel() {
        //   updownfile.down("/api/swyl/v1/bscTopManagementUser/downloadExcelNew", this.q, "post", 'data');
        // },
        //导出
        exportExcelAll() {
            updownfile.down("/api/swyl/v1/bscTopManagementUser/downloadExcel", this.q, "post", 'data');
        },

        //修改ToP用户管理
        handleEdit(value){
            this.newDialog = true;
            this.titleDig = "修改Top用户管理"
            this.disEdit = true;
            this.add = value;
            this.disAdd = true;
            console.log(this.add,"value1233654987115");
            if(value){
                this.top_id = value.id;
             value.code = this.add.scenesCode;
              this.changeChannel(value);
              for (var i =0 ;i< this.shenglist.length; i++){
                if(this.shenglist[i].name == this.add.province){
                  console.log("shenglist",this.shenglist[i])
                  this.handleItemChange1(this.shenglist[i].code,null,null);
                  break;
                }
              }
              //
            }
        },
        //新增TOP用户管理
        create() {
            this.add = {};
            this.newDialog = true;
            this.titleDig = "新增Top用户管理"
            this.disEdit = true;
            // this.add.year = null;
            this.disAdd = false;
        },
        /****************************新增获取用户单位并且带出其他值*********************************/
        showGroupList(value) {
            if(value == "" ){
                return;
            }
            console.log(value,"11225454541511");
            // this.add.isTop = 0
            this.q.userUnitCode = ''
            this.allq.customerName = ''
            this.allq.customerCode= ''
            ss.MuBiao.getUserLoud(value).then(res => {
                console.log(res,"2023101010101")
                if(res){
                    this.customerNameList = res
                    this.add.userUnitCode = res[0].deptId //用户单位编码
                    this.add.bscAddressDataId = res[0].id
                    /****************查看目标对阵用户*****************/
                    // this.allq.customerName = res[0].deptName
                    // this.allq.customerCode= res[0].deptId
                    /************************************************/
                    // this.add.province =  res[0].province//省份名称
                    // this.add.provinceId =  res[0].provinceId//省份编码
                    // this.add.city =  res[0].city//地市名称
                    // this.add.cityId =  res[0].cityId//地市编码
                    // this.add.year = new Date().getFullYear(); //默认当前年份
                    // console.log(this.add.province ,"this.add.province" );
                    //校验查询用户单位接口返回数据有对应属性值嘛
                    // if(Object.hasOwn(res[0],'schoolTypeName')){
                    //     this.add.schoolTypeName = res[0].schoolTypeName//用户分类
                    // } else{
                    //     this.add.schoolTypeName = '';
                    //     this.add.schoolTypeCode = '';
                    // }
                    // if(Object.hasOwn(res[0],'deptSourceChannel')){
                    //     this.add.scenesCode =  res[0].deptSourceChannel//渠道
                    // }  else{
                    //     this.add.scenesCode = '';
                    // }
                    // console.log(this.add,'this.add');
                    // this.isTopfucation();
                }
            })
        },
        allshowGroupList(value){
            console.log(value,"2023101010");
            this.q.userUnitName= value
        },


        //验证是否为Top用户
        // isTopfucation(){
        //   console.log(this.allq,"this.allq11111111111111111")
        //   ss.grabOrderApi.selectPageTargetAgainstUser(this.allq).then(res => {
        //     console.log(res)
        //     console.log("total", res.total)
        //     this.tableData = res.records
        //     this.q.total = res.total
        //    if(res){
        //     this.add.isTop = 1
        //    }else{
        //     this.add.isTop = 0
        //    }
        //     console.log("table", this.tableData)
        //   })
        // },
        // 展开折叠
        collapseChange() {
            this.isScreen = !this.isScreen;
        },
        rest() {
            var pageSize = this.q.pageSize;
            var pageNo = this.q.pageNo;
            var total = this.q.total;
            this.q = {
                pageSize: pageSize,
                pageNo: pageNo,
                total: total,
                year: '',
                schoolTypeName: '',
                scenesCode: '',
                status: '',
                userUnitCode:'',
                userUnitName:'',
            }
        },

        //修改提交
        commitUpdate(){
          if (!this.add.year){
            this.$message({
              type: "error",
              message: '年份不能为空！'
            });
            return false;
          }
          if (!this.add.province){
            this.$message({
              type: "error",
              message: '省份不能为空！'
            });
            return false;
          }
          if (!this.add.city){
            this.$message({
              type: "error",
              message: '地市不能为空！'
            });
            return false;
          }
          if (!this.add.scenesCode){
            this.$message({
              type: "error",
              message: '渠道不能为空！'
            });
            return false;
          }
          if (!this.add.schoolTypeName){
            this.$message({
              type: "error",
              message: '用户分类不能为空！'
            });
            return false;
          }
          if (!this.add.userUnitName){
            this.$message({
              type: "error",
              message: '用户单位不能为空'
            });
            return false;
          }
          if (!this.add.isNew&&!(this.add.isNew ==0 ||this.add.isNew==1)){
            this.$message({
              type: "error",
              message: '是否新建不能为空'
            });
            return false;
          }
          if (!this.add.isZhidan&&!(this.add.isZhidan ==0 ||this.add.isZhidan==1)){
            this.$message({
              type: "error",
              message: '是否直单不能为空'
            });
            return false;
          }
          // if (!this.add.isTop&&!(this.add.isTop ==0 ||this.add.isTop==1)){
          //   this.$message({
          //     type: "error",
          //     message: '是否top不能为空'
          //   });
          //   return false;
          // }
          // if (!this.add.isAgainst&&!(this.add.isAgainst ==0 ||this.add.isAgainst==1)){
          //   console.log(this.add.isAgainst,"this.add.isAgainst12");
          //   this.$message({
          //     type: "error",
          //     message: '是否对阵用户不能为空'
          //   });
          //   return false;
          // }
          if (!this.add.q1Target){
            this.$message({
              type: "error",
              message: 'Q1目标不能为空'
            });
            return false;
          }
          if (!this.add.q2Target){
            this.$message({
              type: "error",
              message: 'Q2目标不能为空'
            });
            return false;
          }
          if (!this.add.q3Target){
            this.$message({
              type: "error",
              message: 'Q3目标不能为空'
            });
            return false;
          }
          if (!this.add.q4Target){
            this.$message({
              type: "error",
              message: 'Q4目标不能为空'
            });
            return false;
          }

          if (!this.add.memo){
            this.$message({
              type: "error",
              message: '变更原因不能为空'
            });
            return false;
          }

          for(var i=0; i< this.shenglist.length; i++){
            if(this.shenglist[i].code == this.add.province){
              this.add.provinceId = this.add.province;
              this.add.province = this.shenglist[i].name;
              break;
            }
          }
          for(var i=0; i< this.cityList.length; i++){
            if(this.cityList[i].name== this.add.city){
              this.add.cityId = this.cityList[i].code;
              break;
            }
          }
            ss.grabOrderApi.saveOrUpdateTop(this.add).then(res=> {
                if (res.f) {
                    this.$message({
                        type: "success",
                        message: '修改成功！'
                    });
                    this.newDialog = false;
                    this.selectPageAll();
                }
            })
        },

        //新增提交
        commitCreate(){
            if (!this.add.year){
                this.$message({
                    type: "error",
                    message: '年份不能为空！'
                });
                return false;
            }
          if (!this.add.province){
            this.$message({
              type: "error",
              message: '省份不能为空！'
            });
            return false;
          }
          if (!this.add.city){
            this.$message({
              type: "error",
              message: '地市不能为空！'
            });
            return false;
          }
          if (!this.add.scenesCode){
            this.$message({
              type: "error",
              message: '渠道不能为空！'
            });
            return false;
          }
          if (!this.add.schoolTypeName){
            this.$message({
              type: "error",
              message: '用户分类不能为空！'
            });
            return false;
          }
            if (!this.add.userUnitName){
                this.$message({
                    type: "error",
                    message: '用户单位不能为空'
                });
                return false;
            }
            if (!this.add.isNew&&!(this.add.isNew ==0 ||this.add.isNew==1)){
                this.$message({
                    type: "error",
                    message: '是否新建不能为空'
                });
                return false;
            }
          if (!this.add.isZhidan&&!(this.add.isZhidan ==0 ||this.add.isZhidan==1)){
            this.$message({
              type: "error",
              message: '是否直单不能为空'
            });
            return false;
          }
            // if (!this.add.isTop&&!(this.add.isTop ==0 ||this.add.isTop==1)){
            //   this.$message({
            //     type: "error",
            //     message: '是否top不能为空'
            //   });
            //   return false;
            // }
            // if (!this.add.isAgainst&&!(this.add.isAgainst ==0 ||this.add.isAgainst==1)){
            //   console.log(this.add.isAgainst,"this.add.isAgainst12");
            //   this.$message({
            //     type: "error",
            //     message: '是否对阵用户不能为空'
            //   });
            //   return false;
            // }
            if (!this.add.q1Target){
                this.$message({
                    type: "error",
                    message: 'Q1目标不能为空'
                });
                return false;
            }
            if (!this.add.q2Target){
                this.$message({
                    type: "error",
                    message: 'Q2目标不能为空'
                });
                return false;
            }
            if (!this.add.q3Target){
                this.$message({
                    type: "error",
                    message: 'Q3目标不能为空'
                });
                return false;
            }
            if (!this.add.q4Target){
                this.$message({
                    type: "error",
                    message: 'Q4目标不能为空'
                });
                return false;
            }

            if (!this.add.memo){
                this.$message({
                    type: "error",
                    message: '变更原因不能为空'
                });
                return false;
            }
            console.log( this.add.province," this.add.province");
          for(var i=0; i< this.shenglist.length; i++){
            if(this.shenglist[i].code == this.add.province){
              this.add.provinceId = this.add.province;
              this.add.province = this.shenglist[i].name;
              break;
            }
          }
          for(var i=0; i< this.cityList.length; i++){
            if(this.cityList[i].name== this.add.city){
              this.add.cityId = this.cityList[i].code;
              break;
            }
          }
            ss.grabOrderApi.insertTopManagement(this.add).then(res=>{
                if (res.msg != 1 && res.f == true){
                    this.selectPageAll();
                    this.closeDialog();
                }
            })
        },


        exit() {
            this.closeDialog()
        },

      //判断是不是季度的第一周
      isFirstQuarterWeek() {
        const month = this.today.getMonth();
        const quarterStartMonth = Math.floor(month / 3) * 3;
        const quarterStartDate = new Date(this.today.getFullYear(), quarterStartMonth, 1);
        const firstWeekStartDate = new Date(quarterStartDate);
        const dayOfWeek = firstWeekStartDate.getDay();
        firstWeekStartDate.setDate(firstWeekStartDate.getDate() - dayOfWeek); // 调整为当周的第一天

        return (
            this.today >= firstWeekStartDate &&
            this.today < new Date(firstWeekStartDate.getTime() + 8 * 24 * 60 * 60 * 1000)
        );
      },


//初始化数据
        closeDialog(){
            this.newDialog = false,
                this.add.year = '',//年份
                this.add.id ='',
                this.add.province ='',//省份
                this.add.provinceId ='',//省份编码
                this.add.scenesCode ='',//渠道
                this.add.city = '',//地市
                this.add.userUnitName ='',//用户单位name
                this.add.userUnitCode ='',//用户编码
                this.add.bscAddressDataId ='',//用户单位主键
                this.add.schoolTypeName ='',//用户分类name
                this.add.schoolTypeCode ='',//用户分类编码
                this.add.isNew ='',//是否新建
                this.add.isZhidan='',//是否直单
                // this.add.isTop ='',//是否top
                // this.add.isAgainst ='',//是否对阵
                this.add.q1Target ='',//Q1目标
                this.add.q2Target ='',//Q2目标
                this.add.q3Target ='',//Q3目标
                this.add.q4Target ='',//Q4目标
                this.add.memo ='', //备注this.add.
                //重新打开弹出窗，刷新校验
                this.selectPageAll();
                this.$refs.add.resetFields();
        },
        closeDialogs(){
            this.newDialog = false,
                //重新打开弹出窗，刷新校验
                this.selectPageAll();
                this.$refs.add.resetFields();
        },
      loadArea(i) {
        let proSelect = {
          pcode: 0,
          level: 1,
        }
        console.log(proSelect)
        ss.Dictservice.arealist(proSelect).then(rd => {
          this.shenglist = rd;
        })
      },
        getQudaoList() {
            ss.Dictservice.listbycategory("sales_region").then(rd => {
                this.qudaoList = rd;
            })
        },
        // getWeeks(y) {
        //     ss.MuBiao.getWeekList({year: y}).then(rd => {
        //         this.weekList = rd;
        //     })
        // },
    },
    created() {
        this.selectPageAll()
        // this.getWeeks(new Date().getFullYear());
        this.getQudaoList();
        for (var i = 2024; i <= new Date().getFullYear() + 30; i++) {
            this.qyearList.push(i);
        }
        this.add.year = new Date().getFullYear();
        // this.loadArea();
      this.loadArea();
      this.changeFlag = !this.isFirstQuarterWeek();
      this.isjlFlag = this.$store.getters.hasRole('swyl_quyujl,swyl_daqujl');
      this.isAdmin = this.$store.getters.hasRole('swyl_admin');
    },
    components: {
        uploaddownexcel,
    },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
    width: 100px;
}


/deep/ .h-formbLine .el-form-item__content {
    width: 150px;
}
.active{
    color:red;
}
</style>
